import { render, staticRenderFns } from "./Kurumlar.vue?vue&type=template&id=659370a6&scoped=true"
import script from "./Kurumlar.vue?vue&type=script&lang=js"
export * from "./Kurumlar.vue?vue&type=script&lang=js"
import style0 from "./Kurumlar.vue?vue&type=style&index=0&id=659370a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659370a6",
  null
  
)

export default component.exports